module.exports = __webpack_public_path__ + "static/HUIPUT_slogan_EN-05-e11276629ba9a4843fec40176c9d0f08.svg";